import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface DeliveryAddress {
  latitude: number;
  longitude: number;
  city: string;
  state: string;
  country: string;
  pincode: string;
  address: string;
  addressType: number;
  phoneNo: string;
  countryCode: string;
  name: string;
  email: string;
  houseNo?: string;
  landMark?: string;
}

@Component({
  selector: 'megastore-admin-address-details',
  templateUrl: './address-details.component.html',
  styleUrls: ['./address-details.component.scss']
})
export class AddressDetailsComponent {
    addressType: any = {
        1: 'Home',
        2: 'Office',
        3: 'Other'
    }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { data: DeliveryAddress },
    private dialogRef: MatDialogRef<AddressDetailsComponent>
  ) {}

  getAddressTypeText(addressType: number): string {
    return addressType === 1 ? 'Home' : 'Office';
  }

  openGoogleMaps(): void {
    const { latitude, longitude } = this.data.data;
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, '_blank');
  }

  close(): void {
    this.dialogRef.close();
  }
} 